module.exports = __webpack_public_path__ + "static/media/comingSoon.edfdd8d9.png";